import React, { useContext } from 'react'
import styled from 'styled-components'
import { social } from '../listas/social'
import { Icon } from '@iconify/react/dist/iconify.js'
import { ContextoDonacion } from '../contextos/Donacion'

const Footer = () => {
    const { cambiar } = useContext(ContextoDonacion)

    return (
        <Container>
            <Sociales>
                {social.map((element) => {
                    return (<a key={element.nombre} onClick={() => { element.link === 'donacion' && cambiar() }} href={element.link !== 'donacion' ? element.link : ''}>
                        <Icon icon={element.icono} style={{ fontSize: '36px' }} />
                    </a>)
                })}
            </Sociales>
            <a>
                <span style={{ color: 'white' }}>COPYRIGHT  Ronan Arroyave Erazo</span>
            </a>
        </Container>
    )
}

const Container = styled.footer`
    background-color: var(--primary);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    gap: 20px;
`

const Sociales = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 80%;
    color: white;
`

export default Footer